<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>

    <!-- 搜索  单行 -->
    <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div>

    <!-- 搜索 多行 -->
    <!-- <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div> -->
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <router-link :to="'/inventory/info/' + v.id">
              <div class="st-list-top">
                <div class="t-tit">{{ v.plan_name }}</div>
                <div class="t-time">{{ v.createtime }}</div>
              </div>
              <div class="st-list-main">
                <p>仓库位置：{{ v.warehouse_place }}</p>
                <p>上次盘点时间：{{ v.last_time }}</p>
                <p>类型总数：{{ v.total_stock }}种</p>
              </div>
              <div class="st-list-bottom">
                <div class="st-peo">盘点负责人：{{ v.admin_name }}</div>
                <div class="st-status">盘点时间：{{ v.last_time }}</div>
              </div>
            </router-link>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <router-link :to="'/inventory/info/' + v.id">
              <div class="st-list-top">
                <div class="t-tit">{{ v.plan_name }}</div>
                <div class="t-time">{{ v.createtime }}</div>
              </div>
              <div class="st-list-main">
                <p>仓库位置：{{ v.warehouse_place }}</p>
                <p>上次盘点时间：{{ v.last_time }}</p>
                <p>类型总数：{{ v.total_stock }}种</p>
              </div>
              <div class="st-list-bottom">
                <div class="st-peo">盘点负责人：{{ v.admin_name }}</div>
                <div class="st-status">盘点中</div>
              </div>
            </router-link>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <router-link :to="'/inventory/info/' + v.id + '/false'">
              <div class="st-list-top">
                <div class="t-tit">{{ v.plan_name }}</div>
                <div class="t-time">{{ v.createtime }}</div>
              </div>
              <div class="st-list-main">
                <p>仓库位置：{{ v.warehouse_place }}</p>
                <p>上次盘点时间：{{ v.last_time }}</p>
                <p>类型总数：{{ v.total_stock }}种</p>
              </div>
              <div class="st-list-bottom">
                <div class="st-peo">盘点负责人：{{ v.admin_name }}</div>
                <div class="st-status">已盘点</div>
              </div>
            </router-link>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      order_code: "",
      sku: "",
      tabTitle: ["待盘点", "盘点中", "已盘点"],
      cur: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("inventory_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("inventory_activeIndex", value);
    },
    // 分页
    async onLoad() {
      let result = await this.$post(this.$api.stGetPandianList, {
        order_code: this.order_code,
        status: this.cur,
        page: this.page,
        sku: this.sku,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "盘点" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
/* 2行input start */
// .tab-content-list {
//   padding-top: 220px;
// }
/* 2行input  end */
.pan-0 .t-tit {
  border-left: 3px solid #00baad;
}
.pan-1 .t-tit {
  border-left: 3px solid #ff8d1a;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.tab-content .st-list-bottom {
  display: flex;
  padding: 10px;
  border-radius: 5px;
  background: #e9ebf5;
}
.st-list-bottom .st-peo {
  flex: 1;
}
.tab-content .pan-2 .st-list {
  background: #fafbfc;
}
</style>
